import React from 'react';
import { useSpring, animated } from 'react-spring';

const Zoom = ({ children, open = true, ...properties }) => {
	const trans = (s) => `scale(${s})`;
	const [props, set] = useSpring(() => ({
		s: 0.9,
		config: { mass: 5, tension: 350, friction: 40 },
	}));
	return (
		<animated.span
			onMouseMove={() => set({ s: 1 })}
			onMouseLeave={() => set({ s: 0.9 })}
			style={{ transform: props.s.interpolate(trans) }}
			{...properties}
		>
			{children}
		</animated.span>
	);
};

export default Zoom;
